export default __webpack_public_path__ + "./fonts/checkedMenu.d55c8791.svg";